/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from "react";
import "./Landing.css";
import buildingimage from "../../images/building-bg.png";
import buildingimagesecond from "../../images/building-bg-right.png";
import linedcircle from "../../images/lined-circle.png";
import circlehalf from "../../images/circle-half.png";
import buildingleft from "../../images/img-buildingleft.png";
import FooterComponent from "../../Pages/Footer/Footer";
import HeaderComponent from "../../Pages/Header/Header";
import Chatbot from "../Chatbot/Chatbot";
import { useDispatch, useSelector } from "react-redux";
import {
  createNewCommunityGpt,
  getCommunityName
} from "../../Services/Community/CommunityAPI/communityApi";
import { useNavigate } from "react-router-dom";
import { Box, Button } from "@mui/material";
import community_icon from "../../images/Oscar.svg";
import { capitalizeWords } from "../../Utils/LetterCase";
import { toast } from "react-toastify";
import { useLoadScript, Autocomplete } from "@react-google-maps/api";
import { GOOGLE_PLACES_API_KEY } from "../../Utils/Constant";
import { debounce } from 'lodash';
import { ThreeDot } from "react-loading-indicators";
import { encryptId } from "../../Utils/Crypto"
import LargeCommunityDirectory from "./LargeCommunityDirectory/LargeCommunityDirectory";
import house_seal from '../../images/House Seal.png'

const libraries = ["places"]; // Load the Places API library

function LandingComponent() {
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.createNewCommunityGpt);
  const [chatbotActive, setChatbotActive] = useState(false);
  const [communityName, setCommunityName] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [zipCode, setZipCode] = useState("")
  const [inputValue, setInputValue] = useState("");
  const navigate = useNavigate();
  const [DefaultQuestion, setDefaultQuestion] = useState(false);
  const [RealEstate, setRealEstate] = useState(false);
  const [MarketInsights, setMarketInsights] = useState(false);
  const [MortgageSolutions, setMortgageSolutions] = useState(false);
  const [Insurancemadeasy, setInsurancemadeasy] = useState(false);
  const [mes, setMes] = useState("");
  const [communityNameData, setCommunityNameData] = useState([])
  const [showDropDown, setShowDropDown] = useState(false);
  const [locationId, setLocationId] = useState("")
  const [errors, setErrors] = useState({});
  const [id, setId] = useState("")
  const [isGenerated, setIsGenerated] = useState(false);
  const [isSelected, setIsSelected] = useState(false)
  const [isPressed, setIsPressed] = useState(false);
  const [placeId, setPlaceId] = useState("");

  const messages = [
    "Please wait! We are building your community profile now!",
    "Hang tight! We're setting things up for you!",
    "Just a moment! Your community is being built!",
    "Almost there! Crafting your perfect profile!",
    "Almost ready! Personalizing your community experience!",
    "Hold on! We’re bringing everything together!"
  ];

  useEffect(() => {
    const lastVisitedPage = localStorage.getItem("lastVisitedPage");
    const isInStandaloneMode = (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) || window.navigator.standalone;

    if (isInStandaloneMode && window.location.pathname === '/') {
      if (lastVisitedPage && !sessionStorage.getItem('redirected')) {
        sessionStorage.setItem('redirected', 'true');
        window.location.href = lastVisitedPage;
      }
    }
    const handleBeforeUnload = () => {
      localStorage.setItem('lastVisitedPage', window.location.pathname);
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  useEffect(() => {
    // Debounced function to fetch community data by communityName
    const fetchCommunityName = debounce(async () => {
      if (communityName.trim()) {
        dispatch(getCommunityName({ communityName: communityName })).then((res) => {
          setCommunityNameData(res?.payload?.data)
          if (res?.payload?.data && !isSelected) {
            setShowDropDown(true)
          } else {
            setShowDropDown(false)
          }
        })
      }
    }, 300);  // Delay of 300ms

    // Call the debounced function when the communityName changes
    fetchCommunityName();

    // Cleanup function to cancel the debounce if communityName changes or component unmounts
    return () => {
      fetchCommunityName.cancel();
    };
  }, [communityName, dispatch, isSelected]);  // Re-run when communityName changes


  const highlightMatch = (suggestion, query) => {
    const startIndex = suggestion.toLowerCase().indexOf(query.toLowerCase());
    if (startIndex === -1) return suggestion;

    const endIndex = startIndex + query.length;
    return (
      <>
        {suggestion.slice(0, startIndex)}
        <span
          style={{
            // textDecoration: 'underline',
            textDecorationColor: '#dd483b', // Underline color (Orange)
            textDecorationThickness: '2px', // Thicker underline
            textUnderlineOffset: '4px', // Space between the text and underline
            transition: 'all 0.3s ease', // Smooth transition for hover
            fontWeight: 'normal', // Reduce font weight for highlighted text
          }}
        >
          {suggestion.slice(startIndex, endIndex)}
        </span>
        {suggestion.slice(endIndex)}
      </>
    );
  };

  const validateForm = () => {
    const errors = {};
    if (!communityName) {
      errors.community_name = "Please enter a community name";
    }

    if (!city) {
      errors.city = "Please enter a city";
    }

    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSelect = (community) => {
    setIsSelected(true)
    setId(community?.id)
    setCommunityName(community?.community_name || "");
    setCity(community?.location?.city || "");
    setInputValue(community?.community_name || "")
    setLocationId(community?.location?.id)
    setIsGenerated(community?.is_generated);
    if (inputValue === communityName) setShowDropDown(false)
  };

  const handleSubmit = async (e) => {
    setMes("")
    if (!inputValueAuto) setShowDropDown(false)
    if (validateForm()) {
      dispatch(
        createNewCommunityGpt({
          community_id: id || null,
          community_name: communityName.trim(),
          community_city: city,
          community_state: state,
          community_zip_code: zipCode,
          location_id: locationId || null,
          place_id: placeId || null,
        })
      )
        // .unwrap()
        .then((res) => {
          if (res?.payload?.status === 404) {
            setMes(
              "Sorry, we were unable to create your community, please contact us for assistance."
            );
          }
          if (res?.payload?.status === 201) {
            toast.success("Community created successfully! You can now view the details.");
            setLocationId("")
            setCity("")
            setState("")
            setZipCode("")
            setId("")
            setTimeout(() => { navigate(`/tab/${encryptId(res?.payload?.data?.community_id)}`); }, 300)
          }
          if (res?.payload?.status === 200) {
            setLocationId("")
            setCity("")
            setState("")
            setId("")
            setZipCode("")
            setTimeout(() => { navigate(`/tab/${encryptId(res?.payload?.data?.community_id)}`); }, 300)
          }
          setInputValue(communityName.trim()); // Ensure the search term matches for filtering
        })
        .catch((error) => {
          console.error(
            "Error fetching community data:",
            error.response || error
          );
        });
    }
  };

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: GOOGLE_PLACES_API_KEY, // Replace with your actual API key
    libraries,
  });

  const [autocomplete, setAutocomplete] = useState(null);
  const [inputValueAuto, setInputValueAuto] = useState("");

  const onLoad = (autocompleteInstance) => {
    setAutocomplete(autocompleteInstance);
  };

  const onPlaceChanged = () => {
    if (autocomplete) {
      const place = autocomplete.getPlace();

      setInputValueAuto(place.formatted_address || place.name);
      setPlaceId(place.place_id || "");

      const addressComponents = place.address_components || [];
      const cityComponent = addressComponents.find(component =>
        component.types.includes("locality")
      );
      const stateComponent = addressComponents.find(component =>
        component.types.includes("administrative_area_level_1")
      );
      const zipCodeComponent = addressComponents.find(component =>
        component.types.includes("postal_code")
      );

      const city = cityComponent?.long_name || "";
      const state = stateComponent?.short_name || "";
      const zipCode = zipCodeComponent?.long_name || null;

      if (city) {
        setCity(city);
        setState(state);
        setZipCode(zipCode);
      }
    }
  };

  if (!isLoaded) {
    return (
      <div>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "100vh",
            flexDirection: "column",
            textAlign: "center",
          }}
        >
          <ThreeDot color="#dd483b" size="medium" text="" textColor="" />
        </Box>
      </div>
    );
  }

  return (
    <>
      <HeaderComponent />
      <section className="one">
        <div className="container">
          {/* <HeaderComponent /> */}
          <div className="banner-content">
            <h1 className="text-center">Al-powered Community Resources</h1>
            <p className="text-center">
              Your gateway to community insights, rules, applications and nearby
              vendors - all in one place for a smoother homeownership
              experience.
            </p>
            <div className="association-content">
              <span>FIND YOUR ASSOCIATION</span>
            </div>
            <div className="d-flex justify-content-center">
              <div className="type-filters">
                {["HOA", "Condo", "Coop", "Timeshare", "Mobile Park"].map((label, index) => (
                  <div className="filter-item" key={label}>
                    <span
                      className={`filter-label`}>
                      {label}
                    </span>
                    {index !== 4 && <div className="divider" />}
                  </div>
                ))}
              </div>
            </div>
            <div className="landing-searchbar">
              <div className="searchbar-inner-wrapper">
                <div className="inner-searchbar mt-3">
                  <div className="input-searchbar loader-block">
                    <input
                      type="text"
                      name="q"
                      id="community"
                      value={communityName}
                      disabled={loading}
                      onChange={(e) => {
                        const value = e.target.value;
                        setCommunityName(value);
                        setInputValue(value);
                        setMes("");
                        setCity("")
                        setInputValueAuto("")
                        setIsSelected(false)
                      }}
                      placeholder="Search by Community Name"
                      autoComplete="off"
                    />
                    <div className="owl_logo_searchbar">
                      <a href="#">
                        <img
                          src={community_icon}
                          alt="owl_logo"
                          width="20"
                          height="20"
                        ></img>
                      </a>
                    </div>
                  </div>
                </div>
                {showDropDown && (inputValue) && Object.keys(communityNameData).length !== 0 ? (
                  <div className={`searchbar-content-info-block suggestions ${showDropDown ? 'visible' : ''}`}>
                    {/* <h1>hkjj</h1> */}

                    <div className="content-inner-wrapper">
                      {Array.isArray(communityNameData) &&
                        communityNameData.map((community, index) => (
                          <div className="content-wrapper-box" key={community?.id}>
                            <div
                              className="main-content-block d-flex justify-content-between border-b-2 border-gray-500 py-1"
                              onClick={() => handleSelect(community)}
                              style={{
                                cursor: "pointer",
                              }}
                            >
                              <div className="community-name-block">
                                {highlightMatch(capitalizeWords(community?.community_name), inputValue)}
                              </div>
                              <div className="community-city-state">
                                <span className="community-city-name">
                                  {community?.location?.city ? `${community?.location?.city}, ` : ""}
                                </span>
                                <span className="community-state-name">
                                  {community?.location?.state}
                                </span>
                              </div>
                            </div>
                          </div>
                        ))}
                    </div>
                  </div>

                ) : (
                  <div className={`searchbar-content-info-block suggestions ${showDropDown && (inputValue) ? 'visible' : ''}`}>
                    {Object.keys(communityNameData).length === 0 && inputValue ? (
                      <div>
                        <div className="cant-find-community-block">
                          {!loading && <h6 className="mt-3 mb-3">
                            Can't find your community?
                          </h6>}
                          <div className="input-searchbar-community">
                            <div
                              style={{
                                display: "flex",
                                gap: "16px",
                                alignItems: "center",
                              }}
                            >
                              <div className="input-auto">
                                <Autocomplete onLoad={onLoad} onPlaceChanged={onPlaceChanged} options={{ types: ['(cities)'], componentRestrictions: { country: "us" } }}>

                                  <input
                                    type="text"
                                    placeholder="Type City..."
                                    value={inputValueAuto}
                                    onChange={(e) => setInputValueAuto(e.target.value)}
                                    style={{
                                      width: "100%",
                                      padding: "8px",
                                      fontSize: "16px",
                                      borderRadius: "20px",
                                    }}
                                  />
                                </Autocomplete>
                              </div>
                              {errors.city && (
                                <div className="error-text">
                                  {errors.city}
                                </div>
                              )}
                              {/* <Button
                                  variant="contained"
                                  style={{
                                    backgroundColor: "#DD483B",
                                    color: "#ffffff",
                                    borderRadius: "20px",
                                    cursor: loading ? "not-allowed" : "pointer",
                                    opacity: loading ? 0.7 : 1,
                                  }}
                                  onClick={handleSubmit}
                                  disabled={loading}
                                >
                                  Submit
                                </Button> */}
                            </div>

                          </div>
                          {loading && (
                            <div className="message_from_admin mt-4 text-center">
                              <div className={`message-from-admin mb-2`}>
                                {messages[0]}
                              </div>
                              <ThreeDot color="#dd483b" size="small" text="" textColor="" />
                            </div>
                          )}
                          <h6 className="mt-3 mb-3">{mes}</h6>
                        </div>
                      </div>
                    ) : <></>}
                  </div>
                )}
                {!inputValueAuto && (
                  <>
                    {loading && !isGenerated && (
                      <div className="message_from_admin mt-4 text-center">
                        <div className={`message-from-admin mb-2`}>
                          {messages[0]}
                        </div>
                        <ThreeDot color="#dd483b" size="small" text="" textColor="" />
                      </div>
                    )}
                    {mes && (
                      <div className="message_from_admin mt-4 text-center">
                        {mes}
                      </div>
                    )}
                  </>
                )}

                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "15px",
                  }}
                >
                  {/* <Button
                    variant="contained"
                    style={{
                      backgroundColor: "#DD483B",
                      color: "#ffffff",
                      borderRadius: "20px",
                      cursor: loading ? "not-allowed" : "pointer",
                      opacity: loading ? 0.7 : 1,
                    }}
                    onClick={handleSubmit}
                    disabled={loading}
                  >
                    {loading ? "Submitting..." : "Submit"}
                  </Button> */}
                  <Button
                    variant="contained"
                    sx={{
                      borderRadius: "50px",
                      px: 4,
                      py: 1,
                      backgroundColor: "#DD483B",
                      cursor: loading ? "not-allowed" : "pointer",
                      fontSize: "16px",
                      fontWeight: "bold",
                      textTransform: "none",
                      color: "white",
                      "&.Mui-disabled": {
                        backgroundColor: "#f57269",
                        color: "#fbd3d3",
                        opacity: 1,
                      },
                    }}
                    onClick={handleSubmit}
                    disabled={loading}
                  >
                    {loading ? "Submitting..." : "Submit"}
                    {/* Sumbit */}
                  </Button>

                </div>
                <div className="oscar_title mt-3 text-center">
                  <p className="m-0 p-0">
                    Ask OSCAR: The Smarter Way to Navigate Real Estate
                  </p>
                </div>
                <div className="chatbot-wrapper">
                  <div
                    className={`chatbot-button ${isPressed ? 'pressed' : ''}`}
                    onMouseDown={() => setIsPressed(true)}
                    onMouseUp={() => setIsPressed(false)}
                    onMouseLeave={() => setIsPressed(false)}
                  >
                    {/* Chat icon */}
                    <div
                      className="owl-logo-lower-blk text-center"
                      onClick={() => {
                        setChatbotActive(!chatbotActive)
                        setDefaultQuestion(true)
                      }}
                    >
                      <div>
                        <a href="#">
                          <img
                            src={community_icon}
                            alt="owl_logo"
                            width="50"
                            height="50"
                          ></img>
                        </a>
                      </div>
                    </div>

                    {/* Ripple effect */}
                    <div className="ripple-container">
                      <div className="ripple-circle delay-0"></div>
                      <div className="ripple-circle delay-400"></div>
                      <div className="ripple-circle delay-800"></div>
                    </div>
                  </div>
                </div>

                {chatbotActive && (
                  <Chatbot
                    setChatBotActive={setChatbotActive}
                    DefaultQuestion={DefaultQuestion}
                    RealEstate={RealEstate}
                    MarketInsights={MarketInsights}
                    MortgageSolutions={MortgageSolutions}
                    Insurancemadeeasy={Insurancemadeasy}
                    setDefaultQuestion={setDefaultQuestion}
                    setRealEstate={setRealEstate}
                    setMarketInsights={setMarketInsights}
                    setMortgageSolutions={setMortgageSolutions}
                    setInsurancemadeeasy={setInsurancemadeasy}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="building-block-left">
          <img src={buildingimage} alt="building-pic"></img>
        </div>
        <div className="building-block-right">
          <img src={buildingimagesecond} alt="building-pic"></img>
        </div>
        <div className="circle-bg">
          <img src={linedcircle} alt="circle-img"></img>
        </div>
      </section >
      <section className="six">
        <div className="">
          <div className="free-trial-box text-center">
            <h2>Join the Fastest Growing Community Association Network Today!</h2>
            <div className="community-onboard-blk d-flex align-items-center justify-content-between">
              <div className="community-assoc-count">
                365,000+
                <span className="d-block">{/* Explicit spacing for clarity */}
                  Community Associations Onboard
                </span>
              </div>
              <div className="community-assoc-count">
                75.5M+
                <span className="d-block">
                  Total Residents
                </span>
              </div>
            </div>
            {/* <p>
              Protect your association from legal risks, streamline<br></br>{" "}
              operations, and stay compliant—all for free.
            </p> */}
            {/* <div className="button-area d-flex justify-content-center">
              <button className="btn btn-outline contact-us" type="submit" onClick={() => navigate("/Contact")}>
                Contact us{" "}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="#222222"
                >
                  <g id="arrow-right-up-line">
                    <path
                      id="Vector"
                      d="M13.9137 10.7054L3.77688 11.0594L3.71871 9.39376L13.8555 9.03977L9.23227 4.72853L10.3689 3.50961L17.073 9.76124L10.8213 16.4653L9.60241 15.3287L13.9137 10.7054Z"
                      fill=""
                    ></path>
                  </g>
                </svg>
              </button>
              <button className="btn btn-outline get-started-trail" type="submit" onClick={() => navigate("/signupone")}>
                Get Started{" "}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="#ffffff"
                >
                  <path d="M13.3364 7.84518L6.16426 15.0173L4.98575 13.8388L12.1579 6.66667H5.83643V5H15.0031V14.1667H13.3364V7.84518Z"></path>
                </svg>
              </button>
            </div> */}
          </div>
        </div>
        <div className="half-circle">
          <img src={circlehalf} alt="half-circle"></img>
        </div>
        <div className="building-bg-area">
          <img src={buildingleft} alt="building"></img>
        </div>
      </section>
      <section className="house-seal-block">
        <div className="">
          <div className="house-seal-box d-flex align-items-center justify-content-around">
            <div className="house-block-img">
              <img src={house_seal} alt="house-seal-img"></img>
            </div>
            <div className="house-seal-content text-center">
              <div className="house-inner-content">
                <h4>Recognized and Endorsed by the</h4>
                <h2 className="fw-bold">State of Florida</h2>
                <h4>for advancing HOA Compliance and Transparency</h4>
              </div>
            </div>
          </div>

        </div>
      </section>
      <section className="">
        <div className="container">
          <LargeCommunityDirectory />
        </div>
      </section>
      <FooterComponent />

    </>
  );
}

export default LandingComponent;
